import 'unfetch/polyfill/index';
import 'element-closest-polyfill';

(function () {
    let citedBy = {
        selectors: {
            list: '.cited-by__list',
            contentListController: '.article-section__citedBy .accordion__control',
            contentList: '.cited-by__content',
            sciteMetricsDropzone: '.sciteMetricsDropzone',
            seeMoreWrapper: '.seeMoreWrapper',
            loadingContentSpinner: '.loading-content',
        },
        classes: {
            seeMore: 'cited-by__see-more',
        },
        content: {
            loadingSpinner:
                '<li class="loading-content" tabindex="0"><span role="alert" aria-label="loading citations"><span aria-hidden="true">loading citations</span></span><div class="loading"></div></li>',
            citedByListContent: '<ul class="rlist cited-by__list"></ul><div class="cited-by__alert"></div>',
            citationsLoadedAlert:
                '<div class="sr-only" tabindex="-1" role="alert" aria-label="Citations loaded"></div>',
        },
        list: null,
        sciteMetricsDropzone: null,
        isTriggered: false,

        init() {
            citedBy.list = document.querySelector(citedBy.selectors.list);
            citedBy.contentListController = citedBy.convertToArray(
                document.querySelectorAll(citedBy.selectors.contentListController)
            );
            citedBy.contentList = document.querySelector(citedBy.selectors.contentList);
            citedBy.sciteMetricsDropzone = citedBy.contentList.querySelector(citedBy.selectors.sciteMetricsDropzone);
            citedBy.control();
        },
        control() {
            citedBy.list?.addEventListener('click', citedBy.seeMoreCitation);
            citedBy.citationFirstCall();
        },
        citationFirstCall() {
            if (
                citedBy.contentList &&
                !citedBy.list &&
                citedBy.sciteMetricsDropzone &&
                citedBy.contentList.dataset.source !== ''
            ) {
                if (citedBy.contentListController.length) {
                    ['click', 'keydown'].forEach(ev => {
                        citedBy.contentListController.forEach(item =>
                            item.addEventListener(ev, citedBy.buildInitContent)
                        );
                    });
                }
            }
        },
        buildInitContent(e) {
            let keycode = e.keyCode ? e.keyCode : e.which;
            if ((keycode === 13 || e.type === 'click') && !citedBy.isTriggered) {
                citedBy.contentList.insertAdjacentHTML('beforeend', citedBy.content.citedByListContent);
                citedBy.list = citedBy.list === null && citedBy.contentList.querySelector('.cited-by__list');

                const ajaxUrlForContent = `${citedBy.contentList.dataset.source}&ajaxRequest=true`;
                citedBy.list.innerHTML = citedBy.content.loadingSpinner;
                const parentLi = citedBy.list.querySelector(citedBy.selectors.loadingContentSpinner);

                setTimeout(() => parentLi.focus(), 350); // waiting for accordion opening

                fetch(ajaxUrlForContent)
                    .then(response => response.json())
                    .then(data => {
                        citedBy.buildCitationHeading(data);
                        citedBy.buildLoadedContent(data, parentLi, citedBy.list);
                        citedBy.init();
                        citedBy.additionalFetchControls();
                    });
                citedBy.isTriggered = true;
            }
        },
        buildCitationHeading(data) {
            const numberOfTimesCitedHtml = `
                <h3>
                    <span class="bald-text">${data.citedByTotalTimesLabel}</span>
                    <span>${data.item.citedCount}</span>
                </h3>
            `;
            if (citedBy.sciteMetricsDropzone) {
                citedBy.sciteMetricsDropzone.insertAdjacentHTML('afterend', numberOfTimesCitedHtml);
            } else {
                citedBy.contentList.insertAdjacentHTML('afterbegin', numberOfTimesCitedHtml);
            }
        },
        buildLoadedContent(data, spinner, parentUl) {
            if (data.item.citations.length) {
                data.item.citations.forEach(citation => {
                    let entryAuthor = '',
                        link =
                            citation.source === 'crossref'
                                ? data.registry.crossrefUrl + citation.doi
                                : `/doi/${citation.doi}`,
                        label = citation.source === 'crossref' ? data.crossrefLinkLabel : data.internalLinkLabel;

                    if (citation.contributors) {
                        citation.contributors.forEach(contributor => {
                            entryAuthor += `<span class="hlFld-ContribAuthor">${contributor.firstName} ${contributor.surname}, </span>`;
                        });
                    }

                    let citationItem = `
                        <li class="citedByEntry">
                            <span class="entryAuthor">${entryAuthor}</span><span>${citation.itemTitle}</span>${
                        citation.parentTitle ? `<span class="seriesTitle">, ${citation.parentTitle}</span>` : ''
                    }<span class="doi">, ${citation.doi}</span>${
                        citation.volume && citation.volume !== '0'
                            ? `<span class="volume">, <b>${citation.volume}</b></span>`
                            : ''
                    }${
                        citation.issue && citation.issue !== '0' ? `<span class="issue">, ${citation.issue}</span>` : ''
                    }${
                        citation.firstPage
                            ? `<span class="page-range">, (${citation.firstPage}${
                                  citation.lastPage ? `-${citation.lastPage}` : ''
                              })</span>`
                            : ''
                    }${citation.year ? `<span class="pub-date">, (${citation.year})</span>` : ''}<span>.</span>
                            <div class="extra-links">
                                <a href="${link}" class="visitable">${label}</a>
                            </div>
                        </li>`;

                    parentUl.insertAdjacentHTML('beforeend', citationItem);
                });
            }
            if (data.seeMoreLink) {
                let seeMoreText = `<li class="citedByEntry seeMoreWrapper"><a href="javascript:void(0)" data-source="${data.seeMoreLink}" class="cited-by__see-more" role="button">See more</a></li>`;
                parentUl.insertAdjacentHTML('beforeend', seeMoreText);
            }
            setTimeout(() => {
                citedBy.additionalContentBuild(spinner, parentUl);
            }, 500);
        },
        additionalContentBuild(spinner, parentUl) {
            const firstNewElement = spinner.nextElementSibling.children[0],
                citedByAlert = parentUl.nextElementSibling,
                seeMoreWrapper = citedBy.list.querySelector(citedBy.selectors.seeMoreWrapper),
                loadingContentSpinner = citedBy.list.querySelector(citedBy.selectors.loadingContentSpinner);

            firstNewElement.tabIndex = 0;
            firstNewElement.focus();
            firstNewElement.addEventListener('blur', citedBy.removeTabIndexAttribute);
            citedBy.list.removeChild(loadingContentSpinner);
            citedBy.list.removeChild(seeMoreWrapper);
            citedByAlert.innerHTML = citedBy.content.citationsLoadedAlert;
        },
        seeMoreCitation(e) {
            if (e.target.classList.contains(citedBy.classes.seeMore)) {
                let parentLi = e.target.closest('li'),
                    ajaxUrl = `${e.target.dataset.source}&ajaxRequest=true`;

                parentLi.insertAdjacentHTML('afterend', citedBy.content.loadingSpinner);

                const loadingContentSpinner = citedBy.list.querySelector(citedBy.selectors.loadingContentSpinner);
                fetch(ajaxUrl)
                    .then(response => response.json())
                    .then(data => {
                        citedBy.buildLoadedContent(data, loadingContentSpinner, citedBy.list);
                        citedBy.additionalSeeMoreControls();
                    });
            }
        },
        convertToArray(nodeList) {
            return Array.prototype.slice.call(nodeList);
        },
        removeTabIndexAttribute(e) {
            e.target.removeAttribute('tabindex');
        },
        additionalControls() {},
        additionalFetchControls() {},
        additionalSeeMoreControls() {},
    };

    UX.citedBy = citedBy;
})();
